import { useSessionContext } from '@/features/auth';

export const useIsSuperUser = (): boolean => {
	return useSessionContext().isSuperUser;
};
